import { Alert, Button } from "@mui/material";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

// Shown when the list of saved reports could not be loaded, so a failure is
// never mistaken for "you have no reports".
const ReportsListError = ({ onRetry, isRetrying = false }) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  return (
    <Alert
      severity={"error"}
      data-testid={"reports-list-error"}
      sx={{ mx: 2, mt: 2 }}
      action={
        <Button
          color={"inherit"}
          size={"small"}
          onClick={onRetry}
          disabled={isRetrying}
          data-testid={"reports-list-retry"}
        >
          {translateLabels(labels.REPORTS_V3_LIST_RETRY, {
            default: "Retry",
          })}
        </Button>
      }
    >
      {translateLabels(labels.REPORTS_V3_LIST_LOAD_FAILED, {
        default: "Couldn't load your reports.",
      })}
    </Alert>
  );
};

export default ReportsListError;
